import { useMediaQuery } from "@nimit9/signet-ui/hooks/use-media-query"
import { createFileRoute, Navigate } from "@tanstack/react-router"
import { z } from "zod"
import { SettingsList } from "./_nav"

const searchSchema = z.object({
  callback: z.string().optional(),
  request_token: z.string().optional(),
})

export const Route = createFileRoute("/settings/")({
  validateSearch: searchSchema,
  component: SettingsIndex,
})

function SettingsIndex() {
  const { callback, request_token } = Route.useSearch()
  const isDesktop = useMediaQuery("(min-width: 768px)")
  // Zerodha OAuth callback → redirect to integrations tab with query params
  if (callback === "zerodha" && request_token) {
    return <Navigate to="/settings/integrations" search={{ callback, request_token }} />
  }
  // Desktop has the left nav, so land on the first section; phone lands on
  // the grouped list itself.
  if (isDesktop) return <Navigate to="/settings/profile" />
  return <SettingsList />
}
